

















import { accountModule, deviceModule, repairModule } from '@app/store'
import CpHeader from '@ui/src/components/CpHeader/CpHeader.vue'
import {
  defineComponent,
  computed,
  ref,
  useRouter,
} from '@nuxtjs/composition-api'
import LogoutModal from '@app/components/common/LogoutModal.vue'
import useAccount from '@app/composable/useAccount'
import urls from '@app/plugins/urls'
import AccountType from '@app/constants/AccountType'

export default defineComponent({
  components: {
    CpHeader,
    LogoutModal,
  },
  setup() {
    const logoutModal = ref(null)
    const showMenu = ref(false)
    const isOpen = ref(false)
    const router = useRouter()
    // const name = computed(() => `${accountModule.name1} ${accountModule.name2}`)
    const { name, salonName, isSalon } = useAccount()
    const hide = () => {
      showMenu.value = false
    }
    const displayName = isSalon.value ? salonName : name
    const toggleMenu = () => {
      showMenu.value = !showMenu.value
      isOpen.value = !isOpen.value
    }

    const logout = () => {
      ;(logoutModal.value as any).show()
    }

    const account = displayName.value.trim()
      ? { name: displayName.value }
      : undefined
    console.log(account)
    const selectDevice = () => {
      deviceModule.clearAll()
      router.push(urls.deviceRegister)
    }

    const selectRepair = () => {
      repairModule.clearAll()
      if (accountModule.accountType === AccountType.salon) {
        window.location.href = urls.salonRepair
      } else {
        router.push(urls.repairRegister)
      }
    }

    const selectMyAccount = () => {
      router.push(`${urls.mypage}`)
    }
    const selectMyAccountInfo = () => {
      router.push(`${urls.mypage}#account-info`)
    }
    const selectMailUpdate = () => {
      router.push(urls.mailReset)
    }
    const selectEdit = () => {
      router.push(urls.accountEdit)
    }
    const selectPasswordUpdate = () => {
      router.push(urls.passwordReset)
    }

    return {
      logoutModal,

      showMenu,
      account,
      hide,
      selectDevice,
      selectRepair,
      toggleMenu,
      selectMyAccount,
      logout,
      selectMailUpdate,
      selectEdit,
      selectPasswordUpdate,
      selectMyAccountInfo,
    }
  },
})
